/**
 * File tags.js.
 * Handles passing data to tags.chime.com iframes
 */

// Initialize GTM iframe
const gtmIframe = document.querySelector('iframe[id="tags_gtm"]');

function postToGtm() {
  const message = 'init';
  const tagsDomain = getTagsDomain();
  const properties = {
    windowState: window.history.state,
    path: window.location.pathname,
    params: window.location.search,
  };

  this?.contentWindow?.postMessage({ message, properties }, tagsDomain);
};

gtmIframe?.addEventListener('load', postToGtm);

// Send click events needed for specific tags to GTM iframe
const cm360Events = [
  { selector: 'a[href^="tel:"]', event: 'tags.phone_link_tapped' },
  { selector: '.dual-cta-link-login', event: 'tags.login_link_tapped' },
  { text: 'Sign Up', event: 'tags.sign_up_text_tapped'},
];

const tikTokEvents = [
  { page: 'apply-credit', selector: '.email-capture-submit', event: 'tags.apply_credit_cta_tapped' },
  { page: 'apply-debit', selector: '.email-capture-submit', event: 'tags.apply_debit_cta_tapped' },
];

const eventMappings = [
  ...cm360Events,
  ...tikTokEvents,
];

eventMappings.forEach(mapping => {
  if (!mapping.page || window.location.href.includes(mapping.page)) {
    if (mapping.text) {
      document.querySelectorAll('a').forEach(link => {
        if (link.textContent === mapping.text) {
          link.addEventListener('click', () => {
            firePostMessageEvent(mapping.event);
          });
        }
      });
    }
    
    if (mapping.selector) {
      document.querySelectorAll(mapping.selector).forEach(link => {
        link.addEventListener('click', () => {
          firePostMessageEvent(mapping.event);
        });
      });
    }
  }
});
